import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { Revisione53State } from '../../../store/revisione53.reducers';

@Injectable()
export class DatiBilancioFieldValidators {
    constructor(private readonly store: Store<Revisione53State>) {}
}
